import React, { useEffect, useState } from "react";

type FlipMode = "FLIP_MIDDLE" | "FLIP_EDGE";

type FollowCursorProps = {
  children: any;
  flipMode?: FlipMode;
  data: {
    offsetX: number;
    offsetY: number;
  };
};

export const FollowCursor: React.FC<FollowCursorProps> = ({
  children,
  flipMode = "FLIP_EDGE",
  data: { offsetX, offsetY },
}) => {
  const [coords, setCoords] = useState({
    x: 0,
    y: 0,
    clientX: 0,
    clientY: 0,
  });

  useEffect(() => {
    const handleWindowMouseMove = (event: MouseEvent) => {
      setCoords({
        x: event.pageX,
        y: event.pageY,
        clientX: event.clientX,
        clientY: event.clientY,
      });
    };

    // test "pointermove" later?
    window.addEventListener("mousemove", handleWindowMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleWindowMouseMove);
    };
  }, []);

  const isReady = Object.values(coords).every((val) => val !== 0);

  if (!isReady) {
    return <></>;
  }

  const flipPoint = {
    FLIP_MIDDLE: {
      x: window.innerWidth / 2,
      y: window.innerHeight / 2,
    },
    FLIP_EDGE: {
      x: window.innerWidth - offsetX * 2 - 10,
      y: window.innerHeight - offsetY * 2 - 10,
    },
  }[flipMode];

  const left =
    flipPoint.x - coords.clientX > 0 ? offsetX + 10 : -(offsetX + 10);

  const top = flipPoint.y - coords.clientY > 0 ? offsetY + 10 : -(offsetY + 10);

  return (
    <div
      style={{
        zIndex: 10,
        pointerEvents: "none",
        position: "absolute",
        transition: "transform 0.25s",
        transform: `translate(${left}px, ${top}px)`,
        left: coords.x - offsetX,
        top: coords.y - offsetY,
        // left: coords.x + 15,
        // top: coords.y + 15,
      }}
    >
      {children}
    </div>
  );
};
